import React, { Component } from 'react';
import { HierarchyMetadata } from 'app/area/shared/codetable/list-item/types';
import { CodetableListItemsContainer } from 'app/area/codetable/list/list-items/codetable-list-items-container';
import { CodetableItemRow } from 'app/area/codetable/list/list-items/common/codetable-item-row';
import { CodetableItemLoader } from 'app/area/shared/codetable/item/codetable-item-loader';
import { ConsequencesCodetableListItemsProps } from 'app/area/codetable/list/list-renderer/types';
import { UomCodetableItem } from 'app/area/codetable/list/list-renderer/screens/uom/uom-codetable-item';
import { UomHeading } from 'app/area/codetable/list/list-renderer/screens/uom/uom-heading';
import styles from './uom-codetable-list-items.scss';

export class UomCodetableListItems extends Component<ConsequencesCodetableListItemsProps> {

  public render() {

    const { itemAccess, fetchingItemAccess, codetableId, parentId, codeListBranch, codeListBranchState,
      codeAccessConfiguration, codeId, isZebra, isHierarchyMode, isHierarchy, breadcrumbs, deletingCodeItem,
      loadFromParent, expandCodeItem, deleteCodeItem, loadCodesAccess, clearCodesAccess,
      metadata, mergeCode, updateMergeCode, options, loadOptions, validation, resetValidation,
      translation, treeDepthLevel, hierarchyMetadata, addLinkFactory } = this.props;

    const currentBranch = codeListBranch.find(item => item.id === parentId);
    const currentCodeItem = currentBranch && currentBranch.items || [];

    const currentBranchState = codeListBranchState && codeListBranchState.find(state => state.id === parentId);
    const fetching = !!currentBranchState && !!currentBranchState.fetching;
    const needsReload = !!currentBranchState && !!currentBranchState.needsReload;

    return <>
      <CodetableListItemsContainer
        parentId={parentId}
        codeBranch={currentBranch}
        codeBranchState={currentBranchState}
        loadFromParent={loadFromParent}>
        {
          treeDepthLevel === 0
            ? <UomHeading translation={translation} metadata={metadata} />
            : null
        }
        {currentCodeItem.map((codeItem, index) => {

          const codeItemState = codeListBranchState && codeListBranchState.find(state => state.id === codeItem.id);
          const open = !!codeItemState && !!codeItemState.open;

          const showSpinner = !!codeItemState && codeItemState.isUpdatingParent && codeItemState.id === codeItem.id;

          const isZebraValue = isZebra === undefined ? index % 2 === 0 : isZebra;

          const isLastChild = !!currentCodeItem && currentCodeItem.length === index + 1;

          const hasChildren = isHierarchyMode && !!codeItem.childrenCount;

          const hierarchyMetadataUpdated: HierarchyMetadata[] = [...hierarchyMetadata, {
            depthLevel: treeDepthLevel,
            hasChildren,
            isLastChild
          }];

          return <div key={codeItem.id} className={codeItem.deletingCodeItem ? styles.deleting : ''}>
            <UomCodetableItem
              itemAccess={itemAccess}
              fetchingItemAccess={fetchingItemAccess}
              breadcrumbs={breadcrumbs}
              isZebra={isZebraValue}
              hierarchyMetadata={hierarchyMetadataUpdated}
              treeDepthLevel={treeDepthLevel}
              codetableId={codetableId}
              codeId={codeId}
              refetching={fetching && needsReload || showSpinner}
              isHierarchyMode={isHierarchyMode}
              isHierarchy={isHierarchy}
              codeAccessConfiguration={codeAccessConfiguration}
              open={open}
              parentId={parentId}
              codeItem={codeItem}
              expandCodeItem={expandCodeItem}
              deleteCodeItem={deleteCodeItem}
              loadCodesAccess={loadCodesAccess}
              clearCodesAccess={clearCodesAccess}
              deletingCodeItem={deletingCodeItem || codeItem.deletingCodeItem}
              translation={translation}
              isLastChild={!open && isLastChild}
              addLinkFactory={addLinkFactory}
              validation={validation}
              resetValidation={resetValidation}
              metadata={metadata}
              mergeCode={mergeCode}
              updateMergeCode={updateMergeCode}
              options={options}
              loadOptions={loadOptions} />
            {open && <div>
              <UomCodetableListItems
                {...this.props}
                hierarchyMetadata={hierarchyMetadataUpdated}
                deletingCodeItem={codeItem.deletingCodeItem || deletingCodeItem}
                parentId={codeItem.id}
                treeDepthLevel={treeDepthLevel + 1}
                isZebra={isZebraValue}
              />
            </div>}
          </div>;
        })}
      </CodetableListItemsContainer>
      {fetching && !needsReload && <CodetableItemRow isZebra={isZebra} isLoader>
        <CodetableItemLoader>
          {translation.loading}
        </CodetableItemLoader>
      </CodetableItemRow>}
    </>;
  }
}
